function initMediaPopup() {
    const mediaPopup = document.querySelector("[js-media-popup]");
    const closeBtn = document.querySelector("[js-close-popup]");
    const popupTriggerEl = document.querySelectorAll(".js-media-popup");

    popupTriggerEl.forEach( el => el.addEventListener("click", openModel));
    closeBtn.addEventListener("click", closeModel);
    document.addEventListener("click", function(evt) {
        if(evt.target.classList.contains("main-content") && mediaPopup.classList.contains("is-open")) {
            closeModel();
        }
    })

    function openModel() {
        document.documentElement.classList.add("js-drawer-open");
        mediaPopup.classList.add("is-open");
    };

    function closeModel() {
        document.documentElement.classList.remove("js-drawer-open");
        mediaPopup.classList.remove("is-open")
    }
};
/*if(document.documentElement.clientWidth > 768) {
    initMediaPopup();
}*/

initMediaPopup();